import React from 'react';
import { cn } from '@hqo/react-hooks';
import { VariantProps, cva } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';

const spinnerVariants = cva('flex-col items-center justify-center', {
  variants: {
    show: {
      true: 'flex',
      false: 'hidden',
    },
  },
  defaultVariants: {
    show: true,
  },
});

const loaderVariants = cva('animate-spin text-system-grey-medium', {
  variants: {
    size: {
      small: 'size-8',
      medium: 'size-10',
      large: 'size-16',
    },
  },
  defaultVariants: {
    size: 'large',
  },
});

interface SpinnerContentProps
  extends VariantProps<typeof spinnerVariants>,
    VariantProps<typeof loaderVariants> {
  className?: string;
  children?: React.ReactNode;
}

export const Spinner = ({ size, show, children, className }: SpinnerContentProps) => (
  <span data-testid="spinner" className={spinnerVariants({ show })}>
    <Loader2 className={cn(loaderVariants({ size }), className)} />
    {children}
  </span>
);
